var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/MemberProfileEdit/MemberProfileEditLocation.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/MemberProfileEdit/MemberProfileEditLocation.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data", "dictionaries"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});frame.set("dictionaries", Object.prototype.hasOwnProperty.call(kwargs, "dictionaries") ? kwargs["dictionaries"] : {});var t_5 = "";t_5 += "\n    <div class=\"MemberProfileEditLocation\">\n        <div class=\"MemberProfileEditLocation-body MemberProfileEdit-scrollbox\">\n            <form class=\"MemberProfileEditLocation-bodyForm\" enctype=\"multipart/form-data\" method=\"post\">\n\n                <div class=\"MemberProfileEditLocation-bodyForm-outer\">\n                    <div class=\"MemberProfileEditLocation-bodyForm-scrollBlock\">\n                        <div class=\"MemberProfileEditLocation-bodyForm-inner\">\n                            <div class=\"MemberProfileEditLocation-bodyForm-category\">\n                                <div class=\"MemberProfileEditLocation-bodyForm-categoryInner\">\n                                    ";
frame = frame.push();
var t_8 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "dictionaries")),"locations");
if(t_8) {t_8 = runtime.fromIterator(t_8);
var t_6;
if(runtime.isArray(t_8)) {
var t_7 = t_8.length;
for(t_6=0; t_6 < t_8.length; t_6++) {
var t_9 = t_8[t_6][0];
frame.set("[object Object]", t_8[t_6][0]);
var t_10 = t_8[t_6][1];
frame.set("[object Object]", t_8[t_6][1]);
frame.set("loop.index", t_6 + 1);
frame.set("loop.index0", t_6);
frame.set("loop.revindex", t_7 - t_6);
frame.set("loop.revindex0", t_7 - t_6 - 1);
frame.set("loop.first", t_6 === 0);
frame.set("loop.last", t_6 === t_7 - 1);
frame.set("loop.length", t_7);
t_5 += "\n                                        <input type=\"checkbox\" id=\"locations-";
t_5 += runtime.suppressValue(t_9, env.opts.autoescape);
t_5 += "\" value=\"";
t_5 += runtime.suppressValue(t_9, env.opts.autoescape);
t_5 += "\" class=\"MemberProfileEditLocation-bodyForm-input\"";
frame = frame.push();
var t_13 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"locations");
if(t_13) {t_13 = runtime.fromIterator(t_13);
var t_12 = t_13.length;
for(var t_11=0; t_11 < t_13.length; t_11++) {
var t_14 = t_13[t_11];
frame.set("itemSelected", t_14);
frame.set("loop.index", t_11 + 1);
frame.set("loop.index0", t_11);
frame.set("loop.revindex", t_12 - t_11);
frame.set("loop.revindex0", t_12 - t_11 - 1);
frame.set("loop.first", t_11 === 0);
frame.set("loop.last", t_11 === t_12 - 1);
frame.set("loop.length", t_12);
if(t_14 == t_9) {
t_5 += "\n                                                        checked\n                                                    ";
;
}
;
}
}
frame = frame.pop();
t_5 += ">\n                                        <label class=\"MemberProfileEditLocation-bodyForm-categoryItem\"\n                                               for=\"locations-";
t_5 += runtime.suppressValue(t_9, env.opts.autoescape);
t_5 += "\"><span>";
t_5 += runtime.suppressValue(t_10, env.opts.autoescape);
t_5 += "</span></label>\n                                    ";
;
}
} else {
t_6 = -1;
var t_7 = runtime.keys(t_8).length;
for(var t_15 in t_8) {
t_6++;
var t_16 = t_8[t_15];
frame.set("key", t_15);
frame.set("val", t_16);
frame.set("loop.index", t_6 + 1);
frame.set("loop.index0", t_6);
frame.set("loop.revindex", t_7 - t_6);
frame.set("loop.revindex0", t_7 - t_6 - 1);
frame.set("loop.first", t_6 === 0);
frame.set("loop.last", t_6 === t_7 - 1);
frame.set("loop.length", t_7);
t_5 += "\n                                        <input type=\"checkbox\" id=\"locations-";
t_5 += runtime.suppressValue(t_15, env.opts.autoescape);
t_5 += "\" value=\"";
t_5 += runtime.suppressValue(t_15, env.opts.autoescape);
t_5 += "\" class=\"MemberProfileEditLocation-bodyForm-input\"";
frame = frame.push();
var t_19 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"locations");
if(t_19) {t_19 = runtime.fromIterator(t_19);
var t_18 = t_19.length;
for(var t_17=0; t_17 < t_19.length; t_17++) {
var t_20 = t_19[t_17];
frame.set("itemSelected", t_20);
frame.set("loop.index", t_17 + 1);
frame.set("loop.index0", t_17);
frame.set("loop.revindex", t_18 - t_17);
frame.set("loop.revindex0", t_18 - t_17 - 1);
frame.set("loop.first", t_17 === 0);
frame.set("loop.last", t_17 === t_18 - 1);
frame.set("loop.length", t_18);
if(t_20 == t_15) {
t_5 += "\n                                                        checked\n                                                    ";
;
}
;
}
}
frame = frame.pop();
t_5 += ">\n                                        <label class=\"MemberProfileEditLocation-bodyForm-categoryItem\"\n                                               for=\"locations-";
t_5 += runtime.suppressValue(t_15, env.opts.autoescape);
t_5 += "\"><span>";
t_5 += runtime.suppressValue(t_16, env.opts.autoescape);
t_5 += "</span></label>\n                                    ";
;
}
}
}
frame = frame.pop();
t_5 += "\n                                </div>\n                            </div>\n                            <div class=\"MemberProfileEditLocation-bodyForm-note\">If you do not see your preferred location listed, you can email the office so it can be included, or you can add it to the experience paragraph of your profile.</div>\n                        </div>\n                    </div>\n                </div>\n\n            </form>\n        </div>\n        <div class=\"MemberProfileEditLocation-buttons\">\n            <div class=\"MemberProfileEditLocation-buttons-button MemberProfileEditLocation-buttons-button--cancel\">\n                cancel\n            </div>\n            <div class=\"MemberProfileEditLocation-buttons-button MemberProfileEditLocation-buttons-button--save\">\n                save\n            </div>\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("MemberProfileEditLocation");
context.setVariable("MemberProfileEditLocation", macro_t_4);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/MemberProfileEdit/MemberProfileEditLocation.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfileEdit/MemberProfileEditLocation.jinja
// module id = 114
// module chunks = 0